import { parseShowcaseData } from 'api/parsers/parseShowcaseData';
import { fetch } from 'api/typedFetch';
import { type RawAppInfo } from 'api/types/AppInfo/RawAppInfo';

type TempExhibitionFix = {
  id: string;
  title: string;
  tiles: {
    icon: string;
    company_id: string;
    title: string;
    category: string;
  }[];
};

export const getData = async () => {
  const response = await fetch('GET_SHOWCASES');

  const data = await response.json();

  return data.map((app) => {
    return parseShowcaseData(app as RawAppInfo & { exhibitions: TempExhibitionFix[] });
  });
};
